<template>
  <span>
    {{ title }}
  </span>
</template>

<script>
export default {
  name: 'RecruiterIcoCriteriaResultTypeYesNo',
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
    variable: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
  },
  computed: {
    title: function () {
      return this.value === 1 ? 'Yes' : 'No';
    },
  },
};
</script>

<style scoped />
